import { State } from "country-state-city";

import { COUNTRY_CODE_ENUMS, CURRENCY_ENUMS } from "../system/globalEnums";

//-------Supported countries of a store
export const countryConstants = {
  DEFAULT_COUNTRY_CODE: COUNTRY_CODE_ENUMS.UNITED_STATES,
  DEFAULT_CURRENCY: CURRENCY_ENUMS.US_DOLLAR,
  //-------Currency a store gets by default from its country
  COUNTRY_CURRENCY_MAP: {
    [COUNTRY_CODE_ENUMS.UNITED_STATES]: CURRENCY_ENUMS.US_DOLLAR,
    [COUNTRY_CODE_ENUMS.CANADA]: CURRENCY_ENUMS.CANADIAN_DOLLAR,
    [COUNTRY_CODE_ENUMS.AUSTRALIA]: CURRENCY_ENUMS.AUSTRALIAN_DOLLAR,
  },
  CURRENCY_OPTIONS: [
    { value: CURRENCY_ENUMS.US_DOLLAR, label: "USD - US Dollar" },
    { value: CURRENCY_ENUMS.CANADIAN_DOLLAR, label: "CAD - Canadian Dollar" },
    {
      value: CURRENCY_ENUMS.AUSTRALIAN_DOLLAR,
      label: "AUD - Australian Dollar",
    },
  ],
  COUNTRY_OPTIONS: [
    { value: COUNTRY_CODE_ENUMS.UNITED_STATES, label: "United States" },
    { value: COUNTRY_CODE_ENUMS.CANADA, label: "Canada" },
    { value: COUNTRY_CODE_ENUMS.AUSTRALIA, label: "Australia" },
  ],
  //-------Address field labels, placeholders and postal code rules per country
  COUNTRY_ADDRESS_CONFIG: {
    [COUNTRY_CODE_ENUMS.UNITED_STATES]: {
      line1Label: "Address",
      line2Label: "Address Line 2",
      cityLabel: "City",
      stateLabel: "State",
      statePlaceHolder: "Select State",
      zipLabel: "ZIP Code",
      zipPlaceHolder: "00000",
      zipRegex: /^\d{5}(-\d{4})?$/,
      zipErrorMessage: "Invalid ZIP Code.",
    },
    [COUNTRY_CODE_ENUMS.CANADA]: {
      line1Label: "Address",
      line2Label: "Address Line 2",
      cityLabel: "City",
      stateLabel: "Province",
      statePlaceHolder: "Select Province",
      zipLabel: "Postal Code",
      zipPlaceHolder: "A0A 0A0",
      zipRegex: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
      zipErrorMessage: "Invalid Postal Code.",
    },
    [COUNTRY_CODE_ENUMS.AUSTRALIA]: {
      line1Label: "Address",
      line2Label: "Address Line 2",
      cityLabel: "Suburb/City",
      stateLabel: "State/Territory",
      statePlaceHolder: "Select State/Territory",
      zipLabel: "Postcode",
      zipPlaceHolder: "0000",
      zipRegex: /^\d{4}$/,
      zipErrorMessage: "Invalid Postcode.",
    },
  },
  //-------State/Province/Territory options of every supported country
  STATE_OPTIONS: {
    [COUNTRY_CODE_ENUMS.UNITED_STATES]: State.getStatesOfCountry(
      COUNTRY_CODE_ENUMS.UNITED_STATES
    ).map((state) => ({ label: state.name, value: state.name })),
    [COUNTRY_CODE_ENUMS.CANADA]: State.getStatesOfCountry(
      COUNTRY_CODE_ENUMS.CANADA
    ).map((state) => ({ label: state.name, value: state.name })),
    [COUNTRY_CODE_ENUMS.AUSTRALIA]: State.getStatesOfCountry(
      COUNTRY_CODE_ENUMS.AUSTRALIA
    ).map((state) => ({ label: state.name, value: state.name })),
  },
};
